import React from 'react';
import { Typography } from 'antd';
import { DATE_FORMAT } from 'common/const/common.const';
import { dateFormatter } from 'common/helpers/date.helper';
import {
  ECommonEntityStatus,
  IBitecoinRewardCategoryModel,
  IBitecoinRewardModel,
} from 'entities/Bitecoin/Bitecoin.models';
import { IMenuItemModel } from 'entities/MenuItem/MenuItem.models';
import { getCommonEntityStatusText } from 'entities/Bitecoin/Bitecoin.helper';

export const bitecoinRewardCategoryTableConfig = [
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
    ellipsis: true,
  },
];

export const bitecoinRewardTableConfig = [
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
    render: (value: string) => (
      <Typography.Paragraph ellipsis={{ rows: 3 }} title={value}>
        {value}
      </Typography.Paragraph>
    ),
  },
  {
    title: 'Reward Category',
    dataIndex: 'category',
    key: 'category',
    ellipsis: true,
    render: (value: IBitecoinRewardCategoryModel) => (
      <Typography.Paragraph ellipsis={{ rows: 3 }} title={value.name}>
        {value.name}
      </Typography.Paragraph>
    ),
  },
  {
    title: 'Menu Item',
    dataIndex: 'menuItem',
    key: 'menuItem',
    ellipsis: true,
    render: (value: IMenuItemModel) => (
      <Typography.Paragraph ellipsis={{ rows: 3 }} title={value.name}>
        {value.name}
      </Typography.Paragraph>
    ),
  },
  {
    title: 'Reward Type',
    dataIndex: 'type',
    key: 'type',
  },
  {
    title: 'Bitecoins to redeem',
    dataIndex: 'priceInBitecoins',
    key: 'priceInBitecoins',
    render: (value: string) => <Typography.Paragraph title={value}>{value} bitecoins</Typography.Paragraph>,
  },
  {
    title: 'Availability Period',
    dataIndex: 'startDate',
    key: 'startDate',
    render: (value: string, record: IBitecoinRewardModel) => {
      const { startDate, endDate } = record;

      if (startDate && endDate) {
        return (
          <Typography.Paragraph title={value}>
            {/* @ts-ignore */}
            {dateFormatter(startDate, DATE_FORMAT)} - {dateFormatter(endDate, DATE_FORMAT)}
          </Typography.Paragraph>
        );
      }

      if (startDate && !endDate) {
        return (
          <Typography.Paragraph title={value}>
            {dateFormatter(startDate, DATE_FORMAT)} - No end date
          </Typography.Paragraph>
        );
      }

      return <Typography.Paragraph title={value}>Unlimited</Typography.Paragraph>;
    },
  },
  {
    title: 'Status',
    dataIndex: 'status',
    key: 'status',
    render: (value: string) => (
      <Typography.Paragraph title={value}>{getCommonEntityStatusText(value as ECommonEntityStatus)}</Typography.Paragraph>
    ),
  },
];
